import { combineReducers } from 'redux';

import * as actionTypes from 'modules/interventions/actionTypes';

import isErrorModalVisible from './isErrorModalVisible';
import isVisible from './isVisible';
import showImportedWork from './showImportedWork';
import reducer from '../../../../../global/reducers/generic.loading';

/**
 * @typedef {{
 *  isErrorModalVisible: boolean,
 *  isLoading: boolean,
 *  isVisible: boolean,
 *  showImportedWork: boolean
 * }} WorkOrderState
 */
export default combineReducers({
  isErrorModalVisible,
  isLoading: reducer(actionTypes.IMPORT_WORKS_INTO_INTERVENTION),
  isVisible,
  showImportedWork,
});
